export const getAssetUrl = (filename: string) => {
  return `${import.meta.env.VITE_S3_URL}${encodeURIComponent(filename)}`
}
